var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7026 8.89413C19.7026 3.98248 15.2918 0 9.85137 0C4.4111 0 0 3.98248 0 8.89413C0 13.8058 4.4111 17.7881 9.85137 17.7881C15.2918 17.7881 19.7026 13.8058 19.7026 8.89413ZM9.85137 15.5645C5.77709 15.5645 2.46291 12.5726 2.46291 8.89418C2.46291 5.21579 5.77709 2.22364 9.85137 2.22364C13.9255 2.22364 17.24 5.21579 17.24 8.89418C17.24 12.5726 13.9255 15.5645 9.85137 15.5645Z",
    fill: "#2C3E50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4473 20.2033L19.0004 16.1882C18.159 15.4285 16.8637 15.5663 16.0385 16.3435C15.103 17.2245 14.9129 18.7864 15.8667 19.6475L19.9648 23.3474C20.927 24.2159 22.4871 24.2159 23.4472 23.3474C24.4095 22.4803 24.4095 21.0718 23.4473 20.2033Z",
    fill: "#2C3E50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBlue);
export default __webpack_public_path__ + "static/media/search-blue.795577675f2a1c30711b090e20b854fd.svg";
export { ForwardRef as ReactComponent };